import { useLocation, useParams, useNavigate, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

const OrderDetails = () => {
  const { orderId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [order, setOrder] = useState(state?.order || null);

  useEffect(() => {
    if (!order) {
      axios
        .get(`https://newerp.awasthivitality.com/api/orders/${orderId}`)
        .then((res) => {
          if (res.data && res.data.success && res.data.data) {
            // API returns { order: {...}, items: [...] }
            const orderData = res.data.data.order || res.data.data;
            const items = res.data.data.items || [];
            
            // Transform to match component expectations
            setOrder({
              ...orderData,
              customer_name: orderData.name || orderData.customer_name,
              customer_code: orderData.pr_no || orderData.customer_code,
              patient_id: orderData.patient_id || orderData.customer_id, // Ensure patient_id is set
              customer_id: orderData.customer_id || orderData.patient_id, // Fallback
              order_date_formatted: orderData.order_date_formatted || orderData.order_date,
              total_amount: orderData.product_amount || orderData.total_amount,
              gst_amount: orderData.gst_amount || 0,
              shipping_amount: orderData.delivery_amount || orderData.shipping_amount || 0,
              discount_amount: orderData.discount || orderData.discount_amount || 0,
              received_amount: orderData.received_amt || orderData.received_amount || 0,
              pending_amount: orderData.pending_amt || orderData.pending_amount || 0,
              order_status: orderData.status || orderData.order_status,
              courier_address: {
                pa_name: orderData.pa_name,
                pa_mobile: orderData.pa_mobile,
                pa_address: orderData.pa_address,
                pa_city: orderData.pa_city,
                pa_state: orderData.pa_state,
                pa_pincode: orderData.pa_pincode,
                pa_country: 'India'
              },
              product_details: items.map(item => ({
                product_name: item.product_name || 'N/A',
                quantity: item.quantity || 0,
                price: item.price || 0,
                amount: item.amount || 0
              }))
            });
          }
        })
        .catch((err) => {
          console.error('Error loading order:', err);
          alert('Failed to load order details. Please try again.');
        });
    }
  }, [orderId, order]);

  if (!order) return <div className="loading">Loading order...</div>;

  return (
    <>
      <style>{`
        .container {
  max-width: 1000px;
  margin: 39px auto;       /* Centered on mobile */
  padding: 0 16px;         /* Add padding on small screens */
  background: #fff;
  font-family: Arial, sans-serif;
  color: #222;
  border-radius: 6px;
  box-shadow: 0 0 10px rgb(0 0 0 / 0.1);
  overflow: hidden;
}

@media (min-width: 768px) {
  .container {
    margin: 39px 350px;    /* Restore left margin for desktop */
    padding: 0;            /* Remove padding for desktop */
  }
}

        .section-header {
          background-color: #343a40;
          color: white;
        //   padding: 14px 20px;
          font-weight: 600;
          font-size: 18px;
          border-bottom: 1px solid #23272b;
        }
        .section-body {
          padding: 18px 20px;
          display: flex;
          flex-wrap: wrap;
          gap: 16px 40px;
        }
        .field {
          flex: 1 1 280px;
          font-size: 15px;
          line-height: 1.4;
        }
        .field strong {
          font-weight: 700;
        }
        .field a {
          color: #007bff;
          text-decoration: none;
        }
        .field a:hover {
          text-decoration: underline;
        }
        .courier-address {
          display: flex;
          flex-wrap: wrap;
          gap: 16px 40px;
        }
        .courier-group {
          flex: 1 1 280px;
          font-size: 15px;
          line-height: 1.4;
        }
        /* Product Table */
        .product-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 15px;
        }
        .product-table thead {
          background-color: #06b6d4;
          color: white;
          font-weight: 600;
        }
        .product-table th, .product-table td {
          padding: 12px 15px;
          border: 1px solid #ddd;
          text-align: left;
        }
        .product-table tbody tr:hover {
          background-color: #f8f9fa;
        }
        /* Loading */
        .loading {
          font-size: 20px;
          padding: 80px 0;
          text-align: center;
          color: #666;
          font-weight: 600;
        }
        @media (max-width: 650px) {
          .section-body, .courier-address {
            flex-direction: column;
          }
          .field, .courier-group {
            flex: 1 1 100%;
          }
        }
      `}</style>

      <div className="container">
        {/* <button
          onClick={() => navigate(-1)}
          style={{
            margin: '15px 20px 0 20px',
            padding: '8px 14px',
            cursor: 'pointer',
            borderRadius: '4px',
            border: 'none',
            backgroundColor: '#007bff',
            color: 'white',
            fontWeight: '600',
            fontSize: '14px',
            userSelect: 'none',
          }}
        >
          ← Back
        </button> */}

        {/* Order Details */}
        <div className="section-header">Order Details</div>
        <div className="section-body">
          <div className="field"><strong>Order No :</strong> {order.order_no}</div>
          <div className="field"><strong>Order Date :</strong> {order.order_date_formatted}</div>
          <div className="field">
            <strong>Customer :</strong> {order.customer_name || order.name}{' '}
            {(order.patient_id || order.customer_id) && (order.customer_code || order.pr_no) ? (
              <Link 
                to={`/patient/details/${order.patient_id || order.customer_id}`}
                style={{ color: '#007bff', textDecoration: 'none', marginLeft: '5px' }}
              >
                [{order.customer_code || order.pr_no}]
              </Link>
            ) : null}
          </div>

          <div className="field"><strong>Total Amt :</strong> {order.total_amount}</div>
          <div className="field"><strong>GST Amt :</strong> {order.gst_amount || '0.00'}</div>
          <div className="field"><strong>Shipping Amt :</strong> {order.shipping_amount || '0.00'}</div>

          <div className="field"><strong>Discount Amt :</strong> {order.discount_amount || '0.00'}</div>
          <div className="field"><strong>Grand Total :</strong> {order.grand_total}</div>
          <div className="field"><strong>Pay Status :</strong> {order.order_paystatus}</div>

          <div className="field"><strong>Order Status :</strong> {order.order_status}</div>
          <div className="field"><strong>Payment id :</strong> {order.payment_id}</div>
          <div className="field"><strong>Received Amt :</strong> {order.received_amount || '0'}</div>

          <div className="field"><strong>Pending Amt :</strong> {order.pending_amount || '0'}</div>
          <div className="field"><strong>Payment Mode :</strong> {order.order_paymode}</div>
        </div>

        {/* Courier Address */}
        <div className="section-header">Courier Address</div>
        <div className="section-body courier-address">
          <div className="courier-group"><strong>Name :</strong> {order.courier_address?.pa_name}</div>
          <div className="courier-group"><strong>Mobile :</strong> {order.courier_address?.pa_mobile}</div>
          <div className="courier-group"><strong>Address :</strong> {order.courier_address?.pa_address}</div>

          <div className="courier-group"><strong>City :</strong> {order.courier_address?.pa_city}</div>
          <div className="courier-group"><strong>State :</strong> {order.courier_address?.pa_state}</div>
          <div className="courier-group"><strong>Country :</strong> {order.courier_address?.pa_country}</div>

          <div className="courier-group"><strong>Pin Code :</strong> {order.courier_address?.pa_pincode}</div>
        </div>

        {/* Product Details */}
        <div className="section-header">Product Details</div>
        <table className="product-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Product Quantity</th>
              <th>Product Price</th>
              <th>Product Amount</th>
            </tr>
          </thead>
          <tbody>
            {order.product_details?.map((product, index) => (
              <tr key={index}>
                <td>{product.product_name}</td>
                <td>{product.quantity}</td>
                <td>{product.price}</td>
                <td>{product.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default OrderDetails;